import { render, staticRenderFns } from "./GlucoseReadingsView.vue?vue&type=template&id=2d95d2d2&scoped=true"
import script from "./GlucoseReadingsView.vue?vue&type=script&lang=js"
export * from "./GlucoseReadingsView.vue?vue&type=script&lang=js"
import style0 from "./GlucoseReadingsView.vue?vue&type=style&index=0&id=2d95d2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95d2d2",
  null
  
)

export default component.exports